// Root route boundary — a failed lazy chunk or page render must keep public
// visitors on a branded, recoverable surface instead of React Router's
// developer fallback. It reuses MarketingLayout so the normal nav, footer,
// and consent controls remain available.

import { TriangleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";

import { MarketingLayout } from "@/components/MarketingLayout";
import { MarketingStatusPage } from "@/routes/not-found";

export function MarketingRouteHydrateFallback(): React.ReactElement {
  const { t } = useTranslation();
  return (
    <MarketingLayout>
      <section className="flex min-h-[320px] items-center justify-center bg-[var(--bg-surface)] px-6 py-16">
        <p role="status" className="font-sans text-sm font-medium text-[var(--fg-muted)]">
          {t("route_loading.label")}
        </p>
      </section>
    </MarketingLayout>
  );
}

export function MarketingRouteErrorBoundary(): React.ReactElement {
  const { t } = useTranslation();
  // Raw route errors can contain server or user context, so this public
  // fallback intentionally neither renders nor logs them in the browser.

  return (
    <MarketingLayout>
      <MarketingStatusPage
        icon={<TriangleAlert size={28} aria-hidden="true" />}
        eyebrow={t("route_error.eyebrow")}
        title={t("route_error.title")}
        body={t("route_error.body")}
        action={t("route_error.action")}
      />
    </MarketingLayout>
  );
}
